import {useContext, useEffect, useState} from 'react';
import {collection, onSnapshot, query} from 'firebase/firestore';
import {where} from '-/data/firestoreQuery';

import {db} from '-/firebase';
import {UserContext} from '-/contexts/User';
import {isOutstanding} from '-/data/assignments';

// Live count of the current member's outstanding requirement assignments (ASSIGNED or
// IN_PROGRESS, latest cycle only) — drives the badge on the Assignments menu item.
// Mirrors the query the My Assignments page uses, so the badge and the page agree.
export default function useAssignmentBadge() {
    const {currentUser} = useContext(UserContext);
    const [count, setCount] = useState(0);

    useEffect(() => {
        // Stations (shared apparatus logins) have no individual assignments — skip
        // the query entirely so we don't fire a useless (rules-denied) read.
        if (!currentUser?.uid || currentUser.isStation) {
            setCount(0);
            return undefined;
        }
        const q = query(collection(db, 'requirementAssignments'), where('assignee', 'array-contains', currentUser.uid));
        const unsub = onSnapshot(q, snap => {
            setCount(snap.docs
                .map(d => d.data())
                .filter(d => d.latest !== false && isOutstanding(d.status))
                .length);
        }, err => {
            console.error('Error loading assignment badge count:', err);
            setCount(0);
        });
        return () => unsub();
    }, [currentUser?.uid, currentUser?.isStation]);

    return count;
}
